export class SnapLocations {
  constructor() {
    this.xLocations = [];
    this.yLocations = [];
  }

  setCenter(snapX, snapY) {
    this.xLocations = this.xLocations.filter((loc) => {
      return loc.pageItemID !== 'centerX';
    });
    this.yLocations = this.yLocations.filter((loc) => {
      return loc.pageItemID !== 'centerY';
    });

    const SNAP_TOLERANCE = 8;
    this.xLocations.push({
      pageItemID: 'centerX',
      loc: snapX,
      showDecorator: true,
      tolerance: SNAP_TOLERANCE,
    });
    this.yLocations.push({
      pageItemID: 'centerY',
      loc: snapY,
      showDecorator: true,
      tolerance: SNAP_TOLERANCE,
    });
  }

  setOther(snapX, snapY, tagName, tolerance = 5) {
    this.xLocations = this.xLocations.filter((loc) => {
      return loc.pageItemID !== tagName;
    });
    this.yLocations = this.yLocations.filter((loc) => {
      return loc.pageItemID !== tagName;
    });

    if (snapX !== null && snapX !== undefined) {
      this.xLocations.push({
        pageItemID: tagName,
        loc: snapX,
        showDecorator: true,
        tolerance: tolerance,
      });
    }
    if (snapY !== null && snapY !== undefined) {
      this.yLocations.push({
        pageItemID: tagName,
        loc: snapY,
        showDecorator: true,
        tolerance: tolerance,
      });
    }
  }
}
